var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    { staticClass: "c-headerPublisher", class: _vm.styleAside },
    [_vm._t("caption"), _vm._v(" "), _vm._t("link")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }